<template>
  <div class="">
    <app-table
      :id="tableId"
      :options="options"
      @action="getListAction"
    />
  </div>
</template>

<script>
import CoreLibrary from "../../../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../../../../Config/ApiUrl";
import { TableHelpers } from "../../../../Demo/Tables/mixins/TableHelpers";


export default {
  extends: CoreLibrary,
  name: "dropdown-list",
  mixins: [TableHelpers],
  props: {
    type: String,
  },
  data() {
    return {
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      tableId: "filter-without-wrapper",
      rowData: {},
      options: {
        // cardView: true,
        // cardViewComponent: "grid-view",
        name: 'DropdownList',
        url: actions.DROPDOWN_LIST+'?type='+this.type,
        datatableWrapper: false,
        tableShadow: false,
        showHeader: true,
        columns: [
          {
            title: this.$t("parameter"),
            type: "custom-html",
            key: "value",
            isVisible: true,
            modifier: (value,row) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
        ],
        actions: [
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "none",
          },
          {
            title: this.$t("delete"),
            icon: "trash",
            type: "none",
          },
        ],
        showFilter: false,
        // showSearch: true,
        showCount: true,
        // showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 5,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },
      // userFilterOptions: [
      //   { id: "", value: "All Jobs" },
      //   { id: "active", value: "Active" },
      //   { id: "inprogress", value: "Inprogress" },
      //   { id: "draft", value: "Draft" },
      //   { id: "completed", value: "Completed" },
      // ],
    };
  },

  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
    // this.searchAndSelectFilterOptions();
  },
  methods: {

    getListAction(rowData, actionObj, active) {
      if (actionObj.title == this.$t("delete")) {
          this.deleteParameter(rowData.id);
      } else if (actionObj.title == this.$t("edit")) {
          this.editParameter(rowData.id); 
      }
    },
    editParameter(id) {
      let url = actions.EDIT_DROPDOWN_VALUE+'/'+id;
      this.axiosGet(url)
        .then((response) => {
          this.$emit("edit",response.data);
        })
        .catch(({ error }) => {
          // Trigger after error
        });
    },
    deleteParameter(id) {
      if (confirm("Are you sure you want to delete!")) {
        this.axiosGet(actions.DELETE_DROPDOWN_VALUE+'/'+id)
        .then((res) => {
            this.$toastr.s(res.data.message);
            this.$hub.$emit("reload-" + this.tableId);
        })
        .catch((error) => {
          
        });
      }
    }
  },
  computed: {
    theemMode() {
      return this.$store.state.theme;
    },
  },
};
</script>
